import { render } from "./DeviceStatsPage.vue?vue&type=template&id=e57edb24"
import script from "./DeviceStatsPage.vue?vue&type=script&lang=js"
export * from "./DeviceStatsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__